import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { FeatureFlagProvider } from 'contexts/FeatureFlagContext'
import { StandaloneProvisioningProvider } from 'contexts/StandaloneProvisioningContext'
import { setLocationConfig } from '@the-platform-group/component-library'
import { aws } from 'config'

setLocationConfig({ apiKey: aws.geoplacesApiKey })

createRoot(document.getElementById('root')).render(
  <FeatureFlagProvider>
    <StandaloneProvisioningProvider>
      <App />
    </StandaloneProvisioningProvider>
  </FeatureFlagProvider>,
)
